import { useLanguage } from './LanguageProvider';

interface TrPluralProps<K extends string> {
    labelKey: string;
    defaultValue: {
        [key in Intl.LDMLPluralRule]?: string;
    } & {
        other: string;
    };
    amountKey: K;
    variables?: { [key in K]: string | number };
}

export const TrPlural = <K extends string>({ labelKey, defaultValue, amountKey, variables }: TrPluralProps<K>) => {
    const value = useTrPlural(labelKey, defaultValue, amountKey, variables);

    return <span>{value}</span>;
};

const useTrPlural = <K extends string>(
    labelKey: string,
    defaultValue: {
        [key in Intl.LDMLPluralRule]?: string;
    } & {
        other: string;
    },
    amountKey: K,
    variables?: { [key in K]: string | number },
) => {
    const { pluralRules, t } = useLanguage();
    const number = variables?.[amountKey];

    if (typeof number !== 'number') {
        // eslint-disable-next-line no-console
        console.warn(`variables.${amountKey} must be a number`);

        return '';
    }

    const pluralRuleName = pluralRules(variables?.[amountKey] as number);

    return t(`${labelKey}.${pluralRuleName}`, defaultValue[pluralRuleName] || '', variables);
};
